import React, { useContext, useState, useEffect } from 'react'
import { Button, Divider, ListItem } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { NavLink } from 'react-router-dom'
import './Dashboard.css'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import AuthContext from '@/product/context/auth/authContext'
import CustomDialog from '@/custom/components/organisms/CustomDialog'
import UserContext from '@/product/context/user/userContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
}))

const SideNav = () => {
    const classes = useStyles()
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)

    const { user, loadUser } = authContext
    const { updateProfile, responseStatus: responseStatusUser } = userContext

    const [expanded, setExpanded] = useState('')

    const [avatarDialog, setAvatarDialog] = useState(false)
    const changeAvatarDialog = () => {
        setAvatarDialog(!avatarDialog)
    }

    const handleChange = (panel) => {
        if (expanded === panel) {
            setExpanded('')
        } else {
            setExpanded(panel)
        }
    }

    useEffect(() => {
        if (location.pathname.split('/'[2])) {
            setExpanded(`${location.pathname.split('/')[1]}/${location.pathname.split('/')[2]}`)
        } else if (location.pathname.split('/')[1]) {
            setExpanded(location.pathname.split('/')[1])
        }
    }, [location.pathname])
    useEffect(() => {
        if (location.pathname == '/my-account') {
            localStorage.setItem('activeTab', 'main')
        }
    }, [location])

    const validationArray = Yup.object({
        avatar: Yup.string(),
    })

    const formik = useFormik({
        initialValues: {
            id: user?.id || '',
            avatar: [],
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            updateProfile(values)
        },
    })

    useEffect(() => {
        if (user) {
            formik.values.id = user.id
            formik.values.avatar = user.avatar ? [user.avatar] : []
        }
    }, [user])

    useEffect(() => {
        if (responseStatusUser) {
            if (
                responseStatusUser.from === 'updateProfile' ||
                responseStatusUser.from === 'updatePreference'
            ) {
                if (responseStatusUser.status === 'success') {
                    formik.setSubmitting(false)
                    loadUser()
                    setAvatarDialog(false)
                }
            }
        }
    }, [responseStatusUser])

    const avatar = [
        {
            type: 'uploadDropZone',
            name: 'avatar',
            // icon: 'account_circle',
            titleText: 'Upload Profile Picture',
            class: 'profileEditView',
            folder: 'avatar',
            multiple: false,
            accept: 'image/*',
            avatarMode: true,
            webcam: true,
        },
    ]

    return (
        <div className={user?.admin ? 'sideNav seller-side-nav' : 'sideNav'}>
            {user?.admin ? (
                <></>
            ) : (
                <>
                    {/* <img src="/assets/svg/triangle1.svg" alt="" className="snav-back1" />
                    <img src="/assets/svg/triangle2.svg" alt="" className="snav-back2" /> */}
                    <div className="userAvatarProfile">
                        {user?.avatar ? (
                            <div className="userImageRoot">
                                <img
                                    src={`${global.site_url}/uploads/avatar/${user?.avatar}`}
                                    alt="Avatar"
                                    className="userAvatar large"
                                />
                                <div onClick={changeAvatarDialog} className="iconEdit">
                                    <span className="material-icons-outlined">edit</span>
                                </div>
                            </div>
                        ) : (
                            <div className="userImageRoot">
                                <span className="userInitials large">
                                    {user?.first_name?.charAt(0)}
                                    {user?.last_name?.charAt(0)}{' '}
                                </span>
                                <span
                                    className="material-icons iconEdit"
                                    onClick={changeAvatarDialog}
                                >
                                    photo_camera
                                </span>
                            </div>
                        )}

                        <h4>
                            {'Hello'}{' '}
                            {user?.first_name !== 'null' ? user?.first_name : user?.companyname}
                        </h4>
                    </div>
                </>
            )}

            <ul className="dashNavLinks">
                {user?.admin ? (
                    <>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/seller/dashboard">
                                <span className="d-flex flexHandle">
                                    <img src="/assets/svg/dashboard.svg" alt="" />
                                    Dashboard
                                </span>
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/my-account" id="sideba-account">
                                <span className="d-flex flexHandle">
                                    <span className="material-icons">person</span>
                                    Account
                                </span>
                            </NavLink>
                        </ListItem>
                        {/* <div className="my-payments">
                            <ListItem button onClick={() => handleChange('seller/auctions')}>
                                <div
                                    className={`d-flex justify-content-between align-items-center w-100 test ${
                                        expanded === 'seller/auctions' && 'activeDropdown'
                                    }`}
                                >
                                    <span className="d-flex icon-wrap" id="sidebar_myauctions">
                                        <img src="/assets/svg/auctions.svg" alt="" />
                                        Auction
                                    </span>
                                    {expanded === 'seller/auctions' ? (
                                        <ExpandLess />
                                    ) : (
                                        <ExpandMore />
                                    )}
                                </div>
                            </ListItem>

                            <Collapse
                                in={expanded === 'seller/auctions'}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/auctions/draft"
                                            id="sidebar_draft"
                                        >
                                            Draft
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/auctions/upcoming"
                                            id="sidebar_upcoming"
                                        >
                                            Upcoming
                                        </NavLink>
                                    </ListItem>

                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/auctions/open"
                                            id="sidebar_active"
                                        >
                                            Active
                                        </NavLink>
                                    </ListItem>

                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/auctions/closed"
                                            id="sidebar_sold"
                                        >
                                            Past
                                        </NavLink>
                                    </ListItem>
                                </List>
                            </Collapse>
                        </div> */}
                        <div className="my-listing">
                            <ListItem button onClick={() => handleChange('seller/listing')}>
                                <div
                                    className={`d-flex justify-content-between align-items-center w-100 test ${
                                        expanded === 'seller/listing' && 'activeDropdown'
                                    }`}
                                >
                                    <span className="d-flex icon-wrap" id="sidebar_mylistings">
                                        <img src="/assets/svg/invoice.svg" alt="" />
                                        Listing
                                    </span>
                                    {expanded === 'seller/listing' ? (
                                        <ExpandLess />
                                    ) : (
                                        <ExpandMore />
                                    )}
                                </div>
                            </ListItem>

                            <Collapse
                                in={expanded === 'seller/listing'}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/listing/draft"
                                            id="sidebar_listing_draft"
                                        >
                                            Draft
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/listing/sold"
                                            id="sidebar_listing_sold"
                                        >
                                            Sold
                                        </NavLink>
                                    </ListItem>

                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/listing/open"
                                            id="sidebar_listing_active"
                                        >
                                            Active
                                        </NavLink>
                                    </ListItem>

                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/listing/unsold"
                                            id="sidebar_listing_unsold"
                                        >
                                            Unsold
                                        </NavLink>
                                    </ListItem>
                                </List>
                            </Collapse>
                        </div>
                        {/* <div className="my-payments">
                            <ListItem button onClick={() => handleChange('seller/erp-tool')}>
                                <div
                                    className={`d-flex justify-content-between align-items-center w-100 test ${
                                        expanded === 'seller/erp-tool' && 'activeDropdown'
                                    }`}
                                >
                                    <span className="d-flex icon-wrap" id="sidebar_myauctions">
                                        <img src="/assets/svg/erp-tool.svg" alt="" />
                                        ERP Tool
                                    </span>
                                    {expanded === 'seller/erp-tool' ? (
                                        <ExpandLess />
                                    ) : (
                                        <ExpandMore />
                                    )}
                                </div>
                            </ListItem>

                            <Collapse
                                in={expanded === 'seller/erp-tool'}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/erp-tool/inventory"
                                            id="sidebar_draft"
                                        >
                                            Inventory
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/erp-tool/manifest"
                                            id="sidebar_upcoming"
                                        >
                                            Manifest
                                        </NavLink>
                                    </ListItem>

                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/erp-tool/auctions"
                                        >
                                            Auctions
                                        </NavLink>
                                    </ListItem>
                                </List>
                            </Collapse>
                        </div> */}

                        <ListItem button>
                            <NavLink activeClassName="active" to="/seller/pickup/all">
                                <span className="d-flex flexHandle">
                                    <img src="/assets/svg/pickup.svg" alt="" />
                                    Pickup
                                </span>
                            </NavLink>
                        </ListItem>
                        <div className="my-payments">
                            <ListItem button onClick={() => handleChange('seller/invoices')}>
                                <div
                                    className={`d-flex justify-content-between align-items-center w-100 test ${
                                        expanded === 'seller/invoices' && 'activeDropdown'
                                    }`}
                                >
                                    <span className="d-flex icon-wrap" id="sidebar_invoice">
                                        <img src="/assets/svg/invoice.svg" alt="" />
                                        Invoice
                                    </span>
                                    {expanded === 'seller/invoices' ? (
                                        <ExpandLess />
                                    ) : (
                                        <ExpandMore />
                                    )}
                                </div>
                            </ListItem>

                            <Collapse
                                in={expanded === 'seller/invoices'}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/invoices/all"
                                            id="sidebar_all"
                                        >
                                            All
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/invoices/paid"
                                            id="sidebar_paid"
                                        >
                                            Paid
                                        </NavLink>
                                    </ListItem>

                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/invoices/unpaid"
                                        >
                                            Unpaid
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/invoices/cancel"
                                        >
                                            Cancel
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/invoices/returns"
                                        >
                                            Returns
                                        </NavLink>
                                    </ListItem>
                                </List>
                            </Collapse>
                        </div>

                        {/* <div className="my-payments">
                            <ListItem button onClick={() => handleChange('seller/users')}>
                                <div
                                    className={`d-flex justify-content-between align-items-center w-100 test ${
                                        expanded === 'seller/users' && 'activeDropdown'
                                    }`}
                                >
                                    <span className="d-flex icon-wrap" id="sidebar_users">
                                        <img src="/assets/svg/users.svg" alt="" />
                                        Users
                                    </span>
                                    {expanded === 'seller/users' ? <ExpandLess /> : <ExpandMore />}
                                </div>
                            </ListItem>

                            <Collapse in={expanded === 'seller/users'} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/users/buyers"
                                            id="sidebar_buyers"
                                        >
                                            Buyers
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/users/employees"
                                            id="sidebar_employees"
                                        >
                                            Employees
                                        </NavLink>
                                    </ListItem>
                                </List>
                            </Collapse>
                        </div>
                         */}

                        <ListItem button>
                            <NavLink activeClassName="active" to="/seller/reports">
                                <span className="d-flex flexHandle">
                                    <img src="/assets/svg/reports.svg" alt="" />
                                    Reports
                                </span>
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/seller/warehouse-locations"
                                className="warehouse-link"
                            >
                                <span className="d-flex flexHandle">
                                    <img src="/assets/svg/map-pins.svg" alt="" />
                                    Warehouse Locations
                                </span>
                            </NavLink>
                        </ListItem>
                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/seller/transactions">
                                <span className="d-flex">
                                    <img src="/assets/svg/transaction.svg" alt="" />
                                    Transaction
                                </span>
                            </NavLink>
                        </ListItem> */}

                        <div className="my-payments">
                            <ListItem button onClick={() => handleChange('seller/ordercontrol')}>
                                <div
                                    className={`d-flex justify-content-between align-items-center w-100 test ${
                                        expanded === 'seller/ordercontrol' && 'activeDropdown'
                                    }`}
                                >
                                    <span className="d-flex icon-wrap" id="sidebar_ordercontrol">
                                        <img src="/assets/svg/pickup.svg" alt="" />
                                        Order Control
                                    </span>
                                    {expanded === 'seller/ordercontrol' ? (
                                        <ExpandLess />
                                    ) : (
                                        <ExpandMore />
                                    )}
                                </div>
                            </ListItem>

                            <Collapse
                                in={expanded === 'seller/ordercontrol'}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/ordercontrol/new"
                                            id="sidebar_ordercontrol_new"
                                        >
                                            New
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/ordercontrol/pickup"
                                            id="sidebar_ordercontrol_pickup"
                                        >
                                            Ready for Pickup
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/ordercontrol/completed"
                                            id="sidebar_ordercontrol_completed"
                                        >
                                            Completed
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/seller/ordercontrol/cancelled"
                                            id="sidebar_ordercontrol_cancelled"
                                        >
                                            Cancelled
                                        </NavLink>
                                    </ListItem>
                                </List>
                            </Collapse>
                        </div>
                    </>
                ) : (
                    <>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/cart" id="sidebar-cart">
                                <span className="d-flex flexHandle">
                                    <span className="material-icons">shopping_cart</span>
                                    My Cart
                                </span>
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/my-account" id="sideba-account">
                                <span className="d-flex flexHandle">
                                    <span className="material-icons">person</span>
                                    My Account
                                </span>
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/my-orders"
                                id="sidebar-my-orders"
                            >
                                <span className="d-flex flexHandle">
                                    <span className="material-icons">assignment_return</span>
                                    My Orders
                                </span>
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/favorites/watchlist"
                                id="sidebar_favourite"
                            >
                                <span className="d-flex flexHandle">
                                    <span className="material-icons">favorite</span>
                                    My Favorites
                                </span>
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/offers/allactive"
                                id="sidebar_mybids"
                            >
                                <span className="d-flex flexHandle">
                                    <span className="material-icons">sell</span>
                                    {'My Offers'}
                                </span>
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/payments/saved_cards"
                                id="sidebar_mycards"
                            >
                                <span className="d-flex flexHandle">
                                    <span className="material-icons">credit_card</span>
                                    My Cards
                                </span>
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/wallet" id="sidebar_mywallet">
                                <span className="d-flex flexHandle">
                                    <span className="material-icons">account_balance_wallet</span>
                                    My Wallet
                                </span>
                            </NavLink>
                        </ListItem>

                        {/* <ListItem
                            button
                            onClick={() => handleChange('schedule')}
                            id="sidebar_myinvoices"
                        >
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'schedule' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex">
                                    <span className="material-icons mlr-16">calendar_month</span>
                                    Schedule Pickup
                                </span>
                                {expanded === 'schedule' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem> */}

                        {/* <Collapse in={expanded === 'schedule'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/schedule/pending"
                                        id="sidebar_allinvoices"
                                    >
                                        Pending
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/schedule/completed"
                                        id="sidebar_paid"
                                    >
                                        Completed
                                    </NavLink>
                                </ListItem>
                            </List>
                        </Collapse> */}

                        {/* <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/my-interests"
                                id="sidebar-my-interests"
                            >
                                <img src="/assets/svg/ThumbsUp.svg" alt="" />
                                Interests
                            </NavLink>
                        </ListItem> */}
                        {/* <ListItem button>
                            <NavLink
                                id="sidebar_all_offers"
                                activeClassName="active"
                                to="/alloffers"
                            >
                                <img src="/assets/svg/priority_high.svg" alt="" />
                                <span className="material-icons-outlined">touch_app</span>
                                All Offers
                            </NavLink>
                        </ListItem> */}
                        {/* <div className="my-payments"> */}
                        {/* <ListItem button>
                                <NavLink activeClassName="active" to="/payments/saved_cards">
                                    <span className="d-flex align-items-center">
                                        <span className="material-icons cc-icon">credit_card</span>
                                        Card Details
                                    </span>
                                </NavLink>
                            </ListItem>
                            <ListItem button>
                                <NavLink
                                    activeClassName="active"
                                    to="/wallet"
                                    id="sidebar_mywallet"
                                >
                                    <span className="d-flex align-items-center">
                                        <span className="material-icons">
                                            account_balance_wallet
                                        </span>
                                        My Wallet
                                    </span>
                                </NavLink>
                            </ListItem>
                            {/* <ListItem button onClick={() => handleChange('payments')}>
                                <div
                                    className={`d-flex justify-content-between align-items-center w-100 test ${
                                        expanded === 'payments' && 'activeDropdown'
                                    }`}
                                >
                                    <span className="d-flex align-items-center">
                                        <span className="material-icons cc-icon">credit_card</span>
                                        My Payments
                                    </span>
                                    {expanded === 'payments' ? <ExpandLess /> : <ExpandMore />}
                                </div>
                            </ListItem>
                            <Collapse in={expanded === 'payments'} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/payments/transactions"
                                        >
                                            Transactions
                                        </NavLink>
                                    </ListItem>

                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            to="/payments/saved_cards"
                                        >
                                            Card Details
                                        </NavLink>
                                    </ListItem>
                                </List>
                            </Collapse> */}
                        {/* </div> */}

                        {/* <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/saved_search"
                                id="sidear_savedsearches"
                            >
                                <img src="/assets/svg/bookmark.svg" alt="" /> Saved Search
                            </NavLink>
                        </ListItem> */}
                    </>
                )}
            </ul>
            <CustomDialog
                open={avatarDialog}
                disableBackdropClick
                function={changeAvatarDialog}
                className="qrAccount"
            >
                <div className="d-flex align-items-center accProf mb-4 justify-content-around">
                    {mapData({ formik: formik, data: avatar })}
                </div>

                <div className="actionWrapper">
                    <Button id="cancel" onClick={changeAvatarDialog}>
                        Cancel
                    </Button>
                    <PrimaryButton
                        onClick={formik.handleSubmit}
                        id="avatarsubmit"
                        type="button"
                        disabled={formik.isSubmitting}
                        label="Submit"
                    />
                </div>
            </CustomDialog>
        </div>
    )
}

export default SideNav
